import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ConsultRepository } from '../../repositories/consult.repository';
import { LensiometryEntity } from '../../../data/repositories/consult/entities/lensiometry.entity';
import { LensiometryResponseEntity } from '../../../data/repositories/consult/entities/lensiometry-response.entity';

export class InsertLensiometryUseCase implements UseCase<LensiometryEntity, LensiometryResponseEntity> {
    constructor(private consult: ConsultRepository) { }
    execute(
        params: LensiometryEntity,
    ): Observable<LensiometryResponseEntity> {
        return this.consult.insertLensiometry(params);
    }
}
